module.exports = __webpack_public_path__ + "img/yc-icon.6ab716f7.jpg";